import { LogicContext } from '../types';
import { isIframeWrapperEnabled } from '../utils';

export const setHeaderProperties = async (
  context: LogicContext,
  event: { mainLayoutPath: string; pageTitle: string }
) => {
  if (!isIframeWrapperEnabled()) {
    return {
      updates: [],
    };
  }

  const isPathInNavLinks =
    context.navigationLinks &&
    context.navigationLinks.some(link => link === event.mainLayoutPath);

  const isSearch = !!context.controllersData.search;
  const isPromotions = !!context.controllersData.promotions;

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.Header.properties',
          value: {
            backButtonText: isPathInNavLinks ? 'Sports' : 'Back',
            ...(!!event.pageTitle && {
              title: event.pageTitle,
            }),
            ...(!isPathInNavLinks &&
              isSearch && {
                title: 'Search',
              }),
            ...(!isPathInNavLinks &&
              isPromotions && {
                title: 'Promotions',
              }),
          },
        },
      },
      {
        type: 'hideLayoutComponent',
        data: 'PageHeader',
      },
    ],
  };
};
